document.documentElement.classList.remove('no-js');

document.addEventListener('click', function(e){
  const menu = e.target.closest('[data-mobile-menu]');
  if(menu){
    const nav = document.querySelector('[data-mobile-nav]');
    if(nav) nav.classList.toggle('is-open');
  }
});

document.addEventListener('change', function(e){
  const select = e.target.closest('[data-variant-select]');
  if(!select) return;
  const price = select.options[select.selectedIndex].dataset.price;
  const compare = select.options[select.selectedIndex].dataset.compare;
  const priceEl = document.querySelector('[data-product-price]');
  if(priceEl && price) priceEl.innerHTML = price;
  const compareEl = document.querySelector('[data-product-compare]');
  if(compareEl) compareEl.innerHTML = compare || '';
});

document.addEventListener('submit', function(e){
  const form = e.target.closest('[data-quick-add]');
  if(!form) return;
  e.preventDefault();
  const button = form.querySelector('button');
  if(button){ button.disabled = true; button.textContent = 'Adding…'; }
  fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
    .then(r=>r.json())
    .then(data=>{
      if(button){ button.disabled=false; button.textContent='Added ✓'; setTimeout(()=>button.textContent='Quick Add',1400); }
      const badge=document.querySelector('[data-cart-count]');
      if(badge){
        fetch('/cart.js').then(r=>r.json()).then(cart=>badge.textContent=cart.item_count);
      }
    })
    .catch(()=>{if(button){button.disabled=false;button.textContent='Try Again';}});
});